/*
  Pre-checkout notice — opens snippets/pre-checkout-modal.liquid when the
  customer clicks "Proceed to checkout" on the cart page.

  THE ONE SUBTLE BIT. Shopify decides what a cart form submission means
  by which submit button was used: name="checkout" goes to checkout,
  name="update" just saves quantities. That name is only included in the
  POST when the button itself is what submitted the form. So confirming
  the modal does NOT call form.submit() — that would drop the parameter
  and silently turn "check out" into "update cart", leaving the customer
  on the cart page wondering what happened. Instead a flag is set and
  the real button is clicked again, which submits it properly.

  Fails open by design: if anything here throws or never runs, the
  checkout button is still a plain submit and the customer can still pay.
*/
(function () {
  var modal = document.getElementById('precheckout-modal');
  if (!modal) return;

  var form = document.querySelector('.cart-form');
  if (!form) return;

  var checkoutBtn = form.querySelector('button[name="checkout"]');
  if (!checkoutBtn) return;

  var confirmed = false;
  var lastFocused = null;

  var FOCUSABLE = 'button:not([disabled]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

  function open() {
    lastFocused = document.activeElement;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    var confirmBtn = modal.querySelector('[data-precheckout-confirm]');
    if (confirmBtn) confirmBtn.focus();
    document.addEventListener('keydown', onKeydown);
  }

  function close() {
    modal.hidden = true;
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onKeydown);
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  function onKeydown(e) {
    if (e.key === 'Escape') {
      close();
      return;
    }
    if (e.key !== 'Tab') return;

    // Keep tabbing inside the dialog while it's open.
    var items = Array.prototype.slice.call(modal.querySelectorAll(FOCUSABLE));
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  checkoutBtn.addEventListener('click', function (e) {
    if (confirmed) return; // second click — let it submit for real
    e.preventDefault();
    open();
  });

  modal.addEventListener('click', function (e) {
    if (e.target.closest('[data-precheckout-confirm]')) {
      confirmed = true;
      close();
      checkoutBtn.click();
      return;
    }
    if (e.target.closest('[data-precheckout-close]')) {
      close();
    }
  });
})();
